import React from 'react';

const Contact = () => {
    return (
        <div>
            <header className="header-contact">
                <h3>Contact</h3>
                <hr></hr>
                <h4>Let's connect.</h4>
                <div className="contact-body">
                    <body className="text">
                        I am currently looking for 2021/2022 internship opportunities. Please shoot me an email or connect with me on LinkedIn to start a conversation. I would love to get to know you better and share more about myself!<br></br>
                        <br></br>
                    </body>
                    <a href="mailto: kirtanamogili@gatech.edu" class="contact">Say Hello!</a>
                </div>
            </header>   
        </div>
    )
}

export default Contact;